import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { authActions } from '_store';
import UAVSphere_logo from "../assets/images/UAVspherelogo2.jpg";

export { Login };

function Login() {
    const dispatch = useDispatch();
    const [emailSent, setEmailSent] = useState(false);
    const [sending, setSending] = useState(false);
    const authError = useSelector(state => state.auth.error);

    // form validation rules 
    const validationSchema = Yup.object().shape({
        email: Yup.string().required('Username is required'),
        password: Yup.string().required('Password is required')
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState, getValues } = useForm(formOptions);
    const { errors, isSubmitting } = formState;

    function onSubmit({ email, password }) {
        return dispatch(authActions.login({ email, password }));
    }

    function handleForgotPassword() {
        const email = getValues('email');
        setSending(true);

        dispatch(authActions.forgotPassword({ email }))
            .then(() => {
                setEmailSent(true);
                setSending(false);
            })
            .catch(() => {
                setSending(false);
            });
    }

    return (
        <div className="card m-3">
             <div className="text-center">
            <img 
                src={UAVSphere_logo} 
                alt="UAVSphere Logo" 
                style={{ width: '150px', height: 'auto' }} 
            />
        </div>
            <h4 className="card-header">Login</h4>
            <br/>
            <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-3">
                        <label className="form-label">Username</label>
                        <input name="email" type="text" {...register('email')} className={`form-control ${errors.email ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.email?.message}</div>
                    </div>
                    <br/>
                    <div className="mb-3">
                        <label className="form-label">Password</label>
                        <input name="password" type="password" {...register('password')} className={`form-control ${errors.password ? 'is-invalid' : ''}`} />
                        <div className="invalid-feedback">{errors.password?.message}</div>
                    </div>
                    <br/>
                    <button disabled={isSubmitting} className="btn btn-primary me-2">
                        {isSubmitting && <span className="spinner-border spinner-border-sm me-1"></span>}
                        Login
                    </button>
                    <Link to="../register" className="btn btn-primary me-2">Register</Link>
                                       <button type="button" className="btn btn-primary" onClick={handleForgotPassword} disabled={sending}>
                        {sending ? <span className="spinner-border spinner-border-sm me-1"></span> : 'Forgot Password?'}
                    </button>
                    </form>   
                    {authError && <div className="error-message">{authError}</div>}             
            </div>
            <br/>
            
        </div>
            
    )
}
